var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "more-detail" } }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("fastWizard.tellUsMore")))]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "md-field",
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("fastWizard.websiteFieldLabel"))),
              ]),
              _vm._v(" "),
              _c("md-input", {
                model: {
                  value: _vm.website,
                  callback: function ($$v) {
                    _vm.website = $$v
                  },
                  expression: "website",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "md-helper-text" }, [
                _vm._v(_vm._s(_vm.$t("fastWizard.websiteIntegration"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "md-field",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: {
                    followCursor: true,
                    placement: "bottom-end",
                    zIndex: 99999999999999,
                  },
                  expression:
                    "{\n                    followCursor: true,\n                    placement: 'bottom-end',\n                    zIndex: 99999999999999,\n                }",
                },
              ],
              class: {
                "md-invalid":
                  _vm.errors.first(_vm.$t("message.preferredLanguage")) != null,
              },
              attrs: { content: _vm.$t("fastWizard.vtippyPreferredLanguage") },
            },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.preferredLanguage"))),
              ]),
              _vm._v(" "),
              _c(
                "md-select",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|included:en,tr,ru",
                      expression: "'required|included:en,tr,ru'",
                    },
                  ],
                  attrs: {
                    name: "" + _vm.$t("message.preferredLanguage"),
                    autocomplete: "off",
                  },
                  model: {
                    value: _vm.preferredLanguage,
                    callback: function ($$v) {
                      _vm.preferredLanguage = $$v
                    },
                    expression: "preferredLanguage",
                  },
                },
                [
                  _c("md-option", [
                    _vm._v(_vm._s(_vm.$t("message.selectALanguage"))),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.languages, function (lang) {
                    return _c(
                      "md-option",
                      { key: lang.code, attrs: { value: lang.code } },
                      [
                        _vm._v(
                          _vm._s(_vm.langLabels[lang.code][_vm.$i18n.locale]) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("span", { staticClass: "md-error w-100" }, [
                _vm._v(
                  _vm._s(_vm.errors.first(_vm.$t("message.preferredLanguage")))
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-2" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "md-field",
            {
              class: {
                "md-invalid":
                  _vm.errors.first(_vm.$t("message.rootUserName")) != null,
              },
            },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.rootUserName")))]),
              _vm._v(" "),
              _c("md-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  id: "organizationName",
                  name: _vm.$t("message.rootUserName"),
                  placeholder: _vm.$t("message.rootUserName"),
                  autocomplete: "off",
                  type: "text",
                },
                model: {
                  value: _vm.userName,
                  callback: function ($$v) {
                    _vm.userName = $$v
                  },
                  expression: "userName",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "md-error" }, [
                _vm._v(
                  _vm._s(_vm.errors.first(_vm.$t("message.rootUserName")))
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "md-field",
            {
              class: {
                "md-invalid":
                  _vm.errors.first(_vm.$t("message.organizationName")) != null,
              },
            },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("message.organizationName")))]),
              _vm._v(" "),
              _c("md-input", {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom-end",
                    },
                    expression:
                      "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  id: "organizationName",
                  content: _vm.$t("message.vtipyOrganizationName"),
                  name: _vm.$t("message.organizationName"),
                  placeholder: _vm.$t("message.organizationName"),
                  autocomplete: "off",
                  type: "text",
                },
                model: {
                  value: _vm.organizationName,
                  callback: function ($$v) {
                    _vm.organizationName = $$v
                  },
                  expression: "organizationName",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "md-error" }, [
                _vm._v(
                  _vm._s(_vm.errors.first(_vm.$t("message.organizationName")))
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }